<template lang="pug">
  div
    b-card
      b-form(@submit.prevent='submit')
        b-row
          b-col(sm='6')
            small Object
            h5 {{item.structure.code + " - " + item.structure.name }}
          b-col(sm='6')
            b-form-fieldset.pb-0(label='Customers')
              multiselect(
                id='project_structure_customers' + index
                name='structure_customers' + index
                v-model='projectStructure.customers'
                :multiple='true'
                :options='customersList'
                :loading='customerLoading'
                :internal-search='false'
                @search-change='asyncFindCustomers'
                label='card_name'
                :close-on-select='true'
                track-by='id'
                placeholder='Search a customer here'
              )
        b-row
          b-col(sm='12')
            button.btn.btn-primary.px-4(type='submit') Save
</template>

<script>
  import server from '@/server'
  import Messages from '@/utils/notificationsMsg'
  import RouteGen from '@/utils/apiRoutes'
  import Multiselect from 'vue-multiselect'
  import _ from 'lodash'

  export default {
    name: 'StructureCustomers',
    components: { Multiselect },
    data () {
      return {
        customerLoading: false,
        customersList: [],
        projectStructure: {}
      }
    },
    props: {
      item: {
        type: Object,
        default: {}
      }
    },
    mounted () {
      this.$set(this.$data, 'projectStructure', this.item)
    },
    methods: {
      getResourcesIds (resources) {
        if (resources) { return resources.map((resource) => { return resource.id }) }
      },
      submit () {
        this.saveItem(this.item.id)
      },
      saveItem (itemId = null) {
        let url = '/project-structures/' + itemId
        this.$data.projectStructure.customer_ids = this.getResourcesIds(this.$data.projectStructure.customers)
        server.patch(url, { project_structure: this.$data.projectStructure })
          .then((res) => {
            this.showNotification(201, 'updated')
            this.$set(this.$data, 'projectStructure', res.data.project_structure)
          })
          .catch((err) => {
            this.showNotification(err.response.status)
          })
      },
      asyncFindCustomers: _.debounce(
        function (query) {
          this.customerLoading = true
          let url = RouteGen.index('user')
          server.get(url, {
            params: {
              'q[role_eq]': 'customer',
              'q[card_name_cont]': query
            }
          })
          .then(res => {
            this.$set(this.$data, 'customersList', res.data.users)
            this.customerLoading = false
          })
          .catch(err => {
            console.log(err)
            this.customerLoading = false
          })
        },
        700
      ),
      showNotification (status, modifier) {
        return this.getMessage(Messages.byStatus(status, 'Project', modifier))
      }
    },
    notifications: {
      getMessage: {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Project/StructureCustomers.vue